// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"d1a25d69","502":"dec4c112","596":"de2a3469"}[chunkId] + ".chunk.css";
};